import React from "react";
import ChangePageTitle from "../components/change-title-page";
import CartContent from "../components/component-cart";

function Cart(){
    return(
        <>
            <ChangePageTitle pageTitle="سبد خرید | رستوران باغبان" />
            <CartContent />
        </>
    );
}

export default Cart;